import {
  Component,
  OnInit,
  Inject,
  ViewChild,
  ElementRef
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { FileSystemFileEntry } from 'ngx-file-drop';
import { ApiLogoService } from 'src/app/shared/services/api-logo.service';

@Component({
  selector: 'app-modal-logo',
  templateUrl: './modal-logo.component.html',
  styleUrls: ['./modal-logo.component.css']
})
export class ModalLogoComponent implements OnInit {
  // Loading
  loading;
  step = 'init';
  archivoString64;

  // Data
  archivo;
  ANCHO_IMG = 160;
  fileFinal: any;

  // Elements
  @ViewChild('logo') logoEl: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<ModalLogoComponent>,
    private apiLogoService: ApiLogoService,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.archivo = data.archivo;
  }

  ngOnInit() {
    this.cargarLogoPrevisualizacion();
  }

  cancel(): void {
    this.dialogRef.close();
  }

  aceptar() {
    this.loading = true;

    this.apiLogoService
      .subirLogo(this.fileFinal)
      .then((resAWS: any) => {
        this.apiLogoService
          .guardarLogo(resAWS.location)
          .then(res => {
            this.step = 'ok';
            this.loading = false;
            this.ok();
          })
          .catch(error => {
            this.step = 'error';
            this.loading = false;
          });
      })
      .catch(error => {});
  }

  ok() {
    this.dialogRef.close(true);
  }

  cargarLogoPrevisualizacion() {
    const fileName = this.archivo.name;

    const fileEntry = this.archivo.fileEntry as FileSystemFileEntry;

    fileEntry.file((file: File) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (event: any) => {
        // this.logoEl.nativeElement.src = event.target.result;

        const img = new Image();
        img.src = event.target.result;

        img.onload = () => {
          const height = this.calcularAltura(img);

          const elem = document.createElement('canvas');
          elem.width = this.ANCHO_IMG;
          elem.height = height;
          const ctx = elem.getContext('2d');
          // img.width and img.height will give the original dimensions
          ctx.drawImage(img, 0, 0, this.ANCHO_IMG, height);
          ctx.canvas.toBlob(
            blob => {
              this.fileFinal = new File([blob], 'logo.png', {
                type: 'image/png',
                lastModified: Date.now()
              });

              const readerFinal = new FileReader();
              readerFinal.readAsDataURL(blob);
              readerFinal.onloadend = () => {
                this.logoEl.nativeElement.src = readerFinal.result;
                this.archivoString64 = readerFinal.result;
              };
            },
            'image/png',
            1
          );
        };
      };

      reader.onerror = error => console.log(error);
    });
  }

  calcularAltura(img) {
    return (img.height * this.ANCHO_IMG) / img.width;
  }
}
